const addToCourseModal = document.getElementById('addToCourse');
if (addToCourseModal) {
    //Add student to course
    const stuAddToCourseBtn = document.getElementById('stu-addtocourse');
    stuAddToCourseBtn.addEventListener('click', (e) => {
        //const selectedRadio = document.querySelector('input[name="gid"]:checked').dataset.cid;
        // const selectedRadio = document.querySelector('input[name="gid"]:checked');
        // if (selectedRadio) {
        //     document.querySelector('input[name="cid"]').value = selectedRadio.dataset.cid;
        // }

        let form = document.querySelector('#addToCourse form'),
            formData = new FormData(form);
        const values = Object.fromEntries(formData.entries());

        if (values.gid && values.oid) {
            let preloader = document.createElement('div');

            preloader.classList.add('position-absolute', 'd-flex', 'align-items-center', 'justify-content-center', 'z-2', 'm-3');
            preloader.style.cssText = 'left: 16px;right: 16px;top: 16px;bottom: 16px;background: rgba(255,255,255, 0.5);';
            preloader.innerHTML = '<div class="spinner-border text-brand-primary" role="status"><span class="visually-hidden">Loading...</span></div>'
            document.querySelector('#addToCourse .modal-content').appendChild(preloader);

            postData('/actions/dash/courses.php', values).then((data) => {
                if (data.success) {
                    const myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('addToCourse'));
                    myModal.hide();
                    preloader.remove();
                    coursesList();
                    //document.querySelector(`#addToCourse #cid-${values.cid}`).remove();
                }
            }).catch(error => console.error(error));
        } else {
            if (!values.oid) {document.querySelector('.toast-container').innerHTML += `<div id="liveToast" class="toast align-items-center rounded-3 text-white text-bg-danger" role="alert" aria-live="assertive" aria-atomic="true"><div class="d-flex"><div class="toast-body pt-3 ps-3">Course option not selected</div><button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div></div>`;}
            if (!values.gid) {document.querySelector('.toast-container').innerHTML += `<div id="liveToast" class="toast align-items-center rounded-3 text-white text-bg-danger" role="alert" aria-live="assertive" aria-atomic="true"><div class="d-flex"><div class="toast-body pt-3 ps-3">Course group not selected</div><button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div></div>`;}
            const toastLive = document.getElementById('liveToast')
            const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLive);
            toastBootstrap.show();
            toastLive.addEventListener('hidden.bs.toast', () => {
                toastLive.remove();
            });
        }
    });

    const courseOptions = (data, container) => {
        console.log(data);
        data = JSON.parse(data);
        container.innerHTML = '';

        data.forEach((item) => {
            const wrapper = document.createElement('div');
            wrapper.classList.add('form-check', 'ms-4');

            const input = document.createElement('input');
            input.classList.add('form-check-input');
            input.type = 'radio';
            input.name = 'oid';
            input.id = `oid-${item.id}`;
            input.dataset.cid = item.id;
            input.value = item.id;

            const label = document.createElement('label');
            label.classList.add('form-check-label');
            label.htmlFor = `oid-${item.id}`;
            label.innerText = item.des;

            wrapper.appendChild(input);
            wrapper.appendChild(label);
            container.appendChild(wrapper);
        })
    }

    const courseGroups = (data, container) => {
        container.innerHTML = '';

        data.forEach((item) => {
            const wrapper = document.createElement('div');
            wrapper.classList.add('form-check', 'ms-4');

            const input = document.createElement('input');
            input.classList.add('form-check-input');
            input.type = 'radio';
            input.name = 'gid';
            input.id = `gid-${item.id}`;
            input.dataset.cid = item.id;
            input.value = item.id;

            const label = document.createElement('label');
            label.classList.add('form-check-label');
            label.htmlFor = `gid-${item.id}`;
            label.innerText = item.comment;

            wrapper.appendChild(input);
            wrapper.appendChild(label);
            container.appendChild(wrapper);
        })
    }

    const accordionCG = document.getElementById('accordionCG')
    accordionCG.addEventListener('show.bs.collapse', event => {
        const optContainer = event.target.querySelector('.course-options');
        const groupContainer = event.target.querySelector('.course-groups');
        const sid = document.querySelector('.profile').dataset.sid;
        addToCourseModal.querySelector('input[name="cid"]').value = event.target.dataset.cid;

        postData('/actions/dash/courses.php', {act: 11, cid: event.target.dataset.cid}).then((data) => {
            courseOptions(data.success[0].options, optContainer);
        });

        postData('/actions/dash/courses.php', {act: 12, cid: event.target.dataset.cid, sid: sid}).then((data) => {
            courseGroups(data.success, groupContainer);
        });
    });

    accordionCG.addEventListener('hide.bs.collapse', event => {
        const optContainer = event.target.querySelector('.course-options');
        const groupContainer = event.target.querySelector('.course-groups');

        optContainer.innerHTML = '';
        groupContainer.innerHTML = '';
    });
}